export default __webpack_public_path__ + "static/media/logo-full.8ff702c4.svg";